import { render } from "./01_welcome.vue?vue&type=template&id=7c2cec49"
import script from "./01_welcome.vue?vue&type=script&lang=js"
export * from "./01_welcome.vue?vue&type=script&lang=js"

import "./01_welcome.vue?vue&type=style&index=0&id=7c2cec49&lang=css"
script.render = render

export default script